import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
interface IProps {
    region: IRegionReportPrice;
}
export const PricesCityInfo = (props: IProps) => {
    const regionDescriptions = props.region?.landing_page_descriptions;

    return (
        <>
            {regionDescriptions && regionDescriptions.length > 0 && (
                <Container css={mb(6)}>
                    {regionDescriptions.map((el, index) => {
                        return (
                            <div key={index} css={textHolder}>
                                <Text variant="headline_4" css={mb(2)}>
                                    {el.title}
                                </Text>
                                <Text as="div" variant="body_copy_1">
                                    <p>{el.text}</p>
                                </Text>
                            </div>
                        );
                    })}
                </Container>
            )}
        </>
    );
};

const textHolder = css`
    ${backgroundColor("#fff")};
    ${mb(3)};
    ${p(3)};
    ${borderRadius(2)};
`;
import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
interface IProps {
    region: IRegionReportPrice;
}
export const PricesCityInfo = (props: IProps) => {
    const regionDescriptions = props.region?.landing_page_descriptions;

    return (
        <>
            {regionDescriptions && regionDescriptions.length > 0 && (
                <Container css={mb(6)}>
                    {regionDescriptions.map((el, index) => {
                        return (
                            <div key={index} css={textHolder}>
                                <Text variant="headline_4" css={mb(2)}>
                                    {el.title}
                                </Text>
                                <Text as="div" variant="body_copy_1">
                                    <p>{el.text}</p>
                                </Text>
                            </div>
                        );
                    })}
                </Container>
            )}
        </>
    );
};

const textHolder = css`
    ${backgroundColor("#fff")};
    ${mb(3)};
    ${p(3)};
    ${borderRadius(2)};
`;
